import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateDefaultDeliveryContactInput,
    DefaultDeliveryContact,
    UpdateDefaultDeliveryContactInput
} from '../../services/api/API';

@Injectable({
    providedIn: 'root'
})
export class DefaultDeliveryContactService {
    private amplifyClient = generateClient();

    async defaultDeliveryContactByCompanyId(
        companyId: string
    ): Promise<DefaultDeliveryContact[]> {
        try {
            const result = await this.amplifyClient.graphql({
                query: queries.DefaultDeliveryContactByCompanyId,
                variables: { companyId }
            });
            const data = result.data.DefaultDeliveryContactByCompanyId.items;
            return Array.isArray(data)
                ? (data as DefaultDeliveryContact[])
                : [];
        } catch (error) {
            console.error('Error finding DefaultDeliveryContact:', error);
            return [];
        }
    }

    async defaultDeliveryContactByUserId(
        userId: string
    ): Promise<DefaultDeliveryContact[]> {
        try {
            const result = await this.amplifyClient.graphql({
                query: queries.DefaultDeliveryContactByUserId,
                variables: { userId }
            });
            const data = result.data.DefaultDeliveryContactByUserId.items;
            return Array.isArray(data)
                ? (data as DefaultDeliveryContact[])
                : [];
        } catch (error) {
            console.error(
                'Error finding DefaultDeliveryContact by userId:',
                error
            );
            return [];
        }
    }

    async createDefaultDeliveryContact(
        input: CreateDefaultDeliveryContactInput
    ): Promise<DefaultDeliveryContact | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createDefaultDeliveryContact,
                    variables: { input }
                })
            ).data.createDefaultDeliveryContact;
            return data ? (data as DefaultDeliveryContact) : null;
        } catch (error) {
            console.error('Error creating DefaultDeliveryContact:', error);
            return null;
        }
    }

    async updateDefaultDeliveryContact(
        input: UpdateDefaultDeliveryContactInput
    ): Promise<DefaultDeliveryContact | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateDefaultDeliveryContact,
                    variables: { input }
                })
            ).data.updateDefaultDeliveryContact;
            return data ? (data as DefaultDeliveryContact) : null;
        } catch (error) {
            console.error('Error updating DefaultDeliveryContact:', error);
            return null;
        }
    }

    async deleteDefaultDeliveryContact(id: string): Promise<boolean> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteDefaultDeliveryContact,
                    variables: { input: { id } }
                })
            ).data.deleteDefaultDeliveryContact;
            return !!data;
        } catch (error) {
            console.error('Error deleting DefaultDeliveryContact:', error);
            return false;
        }
    }
}
